import { render, staticRenderFns } from "./InlineTable.vue?vue&type=template&id=863a6368&"
import script from "./InlineTable.vue?vue&type=script&lang=js&"
export * from "./InlineTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports